<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Recaudación</h3>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h5>Información de la consulta</h5>
        <div class="card__controls">
          <button type="button" @click="consultar" class="btn-info">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
        </div>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div class="form-field select">
              <div class="select-field">
                <select
                  v-model="form.tipo_fecha"
                  name="tipo_fecha"
                  id="tipo_fecha"
                >
                  <option value="H">Hoy</option>
                  <option value="A">Ayer</option>
                  <option value="P">Personalizado</option>
                </select>
                <label for="tipo_fecha">Tipo de fecha</label>
              </div>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="fecha"
                  v-model="form.desde"
                  locale="es"
                  no-label
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  only-date
                  formatted="YYYY-MM-DD"
                  label="Seleccione fecha..."
                />
                <label>Desde</label>
              </div>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="fecha"
                  v-model="form.hasta"
                  locale="es"
                  no-label
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  only-date
                  formatted="YYYY-MM-DD"
                  label="Seleccione fecha..."
                />
                <label>Hasta</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  @input="inputRecaudadores"
                  @search="searchRecaudadores"
                  v-model="selectedRecaudador"
                  :options="recaudadores"
                  label="nombre"
                  placeholder="Seleccione..."
                  id="recaudador"
                ></v-select>
                <label for="recaudador">Recaudador(es)</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  @input="inputRutas"
                  @search="onSearchRutas"
                  v-model="selectedRutas"
                  label="descripcion"
                  multiple
                  :options="rutas"
                  placeholder="Seleccione..."
                  id="ruta"
                ></v-select>
                <label for="ruta">Ruta(s)</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select">
              <div class="select-field">
                <select
                  name="dia_cobro"
                  v-model="form.dia_cobro"
                  id="dia_cobro"
                >
                  <option disabled value="">Seleccione...</option>
                  <option value="1">Lunes</option>
                  <option value="2">Martes</option>
                  <option value="3">Miércoles</option>
                  <option value="4">Jueves</option>
                  <option value="5">Viernes</option>
                  <option value="6">Sábado</option>
                  <option value="7">Domingo</option>
                </select>
                <label for="dia_cobro">Día de cobro</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  id="bodega"
                  v-model="selectedBodega"
                  placeholder="Seleccione..."
                  @input="inputBodega"
                  :options="bodegas"
                  label="descripcion"
                ></v-select>
                <label for="bodega">Sucursal</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2">
              <div class="select2-field">
                  <!-- @input="inputEstado" -->
                <v-select
                  id="estado"
                  v-model="selectedEstado"
                  placeholder="Seleccione..."
                  :options="estados"
                  label="descripcion"
                ></v-select>
                <label for="estado">Estado</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-2">
      <div class="card__title">
        <h5>Mapa</h5>
      </div>
      <div class="card__content">
        <div style="height: 700px">
          <l-map
            ref="mymap"
            @update:zoom="zoomUpdated"
            @update:center="centerUpdated"
            style="height: 100%; width: 100%"
            :zoom="zoom"
            :center="center"
          >
            <l-tile-layer :url="url"></l-tile-layer>
            <l-marker
              :name="recaudacion.id"
              v-for="(recaudacion, index) in recaudaciones_filter"
              :key="'recaudacion' + index"
              :icon="recaudacion.icon"
              :lat-lng="[parseFloat(recaudacion.latitud), parseFloat(recaudacion.longitud)]"
            >
              <l-tooltip :options="tooltipOptions"
                >({{ recaudacion.indice }})</l-tooltip
              >
              <l-popup>
                <ul>
                  <li><strong>Recaudador:</strong> {{ recaudacion.nombre_recaudador }}</li>
                  <li><strong>Cliente:</strong> {{ recaudacion.cliente.descripcion }}</li>
                  <li><strong>Venta:</strong> {{ recaudacion.numero_documento }}</li>
                  <li><strong>Ruta:</strong> {{ recaudacion.ruta != null?recaudacion.ruta.nombre:'N/A' }}</li>
                  <li v-if="recaudacion.abono != null"><strong>Fecha:</strong> {{ recaudacion.abono.fecha_abono }}</li><li><strong>Cliente:</strong> {{ recaudacion.cliente.descripcion }}</li>
                  <li v-if="recaudacion.abono != null"><strong>Valor:</strong> {{ moneyFormat(recaudacion.abono.valor_abono) }}</li>
                  <li><strong>Saldo:</strong> {{ moneyFormat(recaudacion.saldo_total) }}</li>
                </ul>
              </l-popup>
            </l-marker>
            <l-polyline :weight="7" :key="index + polyline.color" v-for="(polyline, index) in polylines" :lat-lngs="polyline.latlngs" :color="polyline.color"></l-polyline>
            <l-polyline :weight="2" :key="index" v-for="(polyline, index) in polylines" :lat-lngs="polyline.latlngs" :color="'white'"></l-polyline>
          </l-map>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="form-inline">
              <img src="/images/dias-cobro/1-sm.png" alt="Lunes" /><label
                for="lunes"
                >Pendientes</label
              >
              <img src="/images/dias-cobro/5-sm.png" alt="Cobradas" /><label
                for="cobradas"
                >Cobradas</label
              >
              <img src="/images/dias-cobro/7-sm.png" alt="No cobradas" /><label
                for="no_cobradas"
                >No cobradas</label
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="card mt-2">
          <div class="card__title">
            <h5>Comentarios</h5>
          </div>
          <div class="card__content">
            <div style="max-height: 300px" class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th>Venta</th>
                    <th>Usuario</th>
                    <th>Comentario</th>
                    <th>Fecha de comentario</th>
                    <th>Dirección</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="comentario in comentarios" :key="comentario.id">
                    <td>
                      {{ comentario.venta.numero_documento }}
                    </td>
                    <td>
                      {{ comentario.usuario.nombre }}
                    </td>
                    <td>
                      {{ comentario.comentario }}
                    </td>
                    <td>
                      {{ comentario.fecha_comentario }}
                    </td>
                    <td>
                      <button
                        v-show="comentario.coordenadas_comentario != null"
                        @click="verDireccion(comentario)"
                        class="btn-info btn--text"
                      >
                        <i class="fa fa-map-marker"></i
                        ><span>{{ comentario.direccion }}</span>
                      </button>
                    </td>
                  </tr>
                  <tr v-show="comentarios.length === 0">
                    <td colspan="4">
                      <strong>No se ha encontrado comentarios.</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import randomColor from 'randomcolor';
export default {
  props: {
    bodegas: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },
  data: function () {
    return {
      tooltipOptions: {
        permanent: true,
        //direction: 'bottom',
        opacity: 0.7
      },
      comentarios: [],
      polylines: [],
      moneyFormat: moneyFormat,
      markerIcon: L.icon({
        iconUrl: url + "/images/place.png",
        iconAnchor: [16, 16],
      }),
      recaudaciones: [],
      selectedBodega: null,
      selectedRutas: [],
      selectedRecaudador: null,
      recaudadores: [],
      form: {
        tipo_fecha: "H",
        desde: moment(new Date()).format("YYYY-MM-DD"),
        hasta: moment(new Date()).format("YYYY-MM-DD"),
        recaudador_id: '',
        dia_cobro: "",
        rutas: [],
        bodega_id: "",
        // estado: ""
      },
      rutas: [],
      center: [-2.1408961, -79.9080648],
      zoom: 18,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      estados: [
        {value: 'T', descripcion: 'Todas'},
        {value: 'P', descripcion: 'Pagadas'},
        {value: 'N', descripcion: 'No pagadas'}
      ],
      selectedEstado: null
    };
  },
  computed: {
    recaudaciones_filter: function () {
      let recaudaciones = this.recaudaciones;
      if(this.selectedEstado != null && this.selectedEstado.value != 'T') {
        if(this.selectedEstado.value === 'P')
          recaudaciones = this.recaudaciones.filter( recaudacion => recaudacion.abono != null);
        else
          recaudaciones = this.recaudaciones.filter( recaudacion => recaudacion.abono == null);
      }
      return recaudaciones;
    }
  },
  methods: {
    generarPolylines: function () {
      this.polylines.splice(0, this.polylines.length);
      let recaudadores = _.groupBy(this.recaudaciones, 'recaudador_id');
      for (let key in recaudadores) {
        let polyline = {
          latlngs: [],
          color: randomColor()
        };
        for (let i = 0; i < recaudadores[key].length; i++) {
          if (recaudadores[key][i].latitud != null && recaudadores[key][i].longitud != null) {
            polyline.latlngs.push([parseFloat(recaudadores[key][i].latitud), parseFloat(recaudadores[key][i].longitud)]);
          }
        }
        this.polylines.push(polyline);
      }
    },
    consultar: function () {
      if (this.form.recaudador_id == '') {
        swal('Debe seleccionar un recaudador.', 'Aviso', 'warning');
        return;
      }
      axios.get(url + '/dashboard-recaudaciones', {
        params: this.form
      }).then(({data}) => {
        this.comentarios = data.comentarios;
        let recaudaciones = data.recaudaciones;
        this.recaudaciones.splice(0, this.recaudaciones.length);
        for(let key in recaudaciones) {
          let indice = 0;
          let indexCentral = parseInt(recaudaciones[key].length / 2);
          for (let i = 0; i < recaudaciones[key].length; i++) {
            recaudaciones[key][i].indice = indice++;
            recaudaciones[key][i].icon = L.icon({
                        iconUrl:
                          url +
                          "/images/dias-cobro/" +
                          ((recaudaciones[key][i].abono == null && !recaudaciones[key][i].tiene_comentario?'1-sm':(recaudaciones[key][i].abono == null?'7-sm':'5-sm'))) +
                          ".png",
                        iconAnchor: [16, 16],
                      });
            this.recaudaciones.push(recaudaciones[key][i]);
            this.generarPolylines();
            if(i === indexCentral) {
              this.center = [
                recaudaciones[key][i].latitud,
                recaudaciones[key][i].longitud
              ];
            }
          }
        }
      });
    },
    inputRutas: function () {
      this.form.rutas.splice(0, this.form.rutas.length);
      for (let i = 0; i < this.selectedRutas.length; i++) {
        this.form.rutas.push(this.selectedRutas[i].id);
      }
    },
    inputRecaudadores: function () {
      if (this.selectedRecaudador != null) 
        this.form.recaudador_id = this.selectedRecaudador.id;
      else 
        this.form.recaudador_id = '';
    },
    inputBodega: function () {
      if (this.selectedBodega != null)
        this.form.bodega_id = this.selectedBodega.id;
      else this.form.bodega_id = "";
    },
    // inputEstado: function () {
    //   if (this.selectedEstado != null)
    //     this.form.estado = this.selectedEstado.value;
    //   else this.form.estado = "";
    // },
    searchRecaudadores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.recaudadores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/usuarios?tipo=R&search=" + search,
        true
      );
      xmlhttp.send();
    },
    onSearchRutas: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.rutas = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/rutas?search=" + search, true);
      xmlhttp.send();
    },
    centerUpdated(center) {
      this.center = center;
    },
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
  },
  mounted() {
    const map = this.$refs.mymap.mapObject;
    map.addControl(new L.Control.Fullscreen());
    //this.consultar();
    this.selectedEstado = this.estados[0];
    this
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/general/DashboardRecaudaciones.vue